import { useEffect, useState } from 'react'
import HogTitleGroup from '../HogTitleGroup'
import { useAuthFromContext } from '../../AuthContext'
import { usePrototype } from './PrototypeContext'
import GlobeArt from './GlobeArt'
import AppNav from './AppNav'
import { toPlace } from '../../rules/progression/hive'
import '../LobbyScreen.css'
import './prototype.css'

// Home: where the player stands and the way into a war (the war menu); the
// Hive and War history are in the bottom bar. Before the tutorial, only the
// tutorial, or skipping it for good (after a confirm step).
export default function HomeScreen() {
    const { uid, player, wars, notice, setNotice, pendingInvite, startTutorial, skipTutorial, openHive, openWarMenu, openHistory } = usePrototype()
    const { authStatus, signOut } = useAuthFromContext()
    const [busy, setBusy] = useState(false)
    const [confirmSkip, setConfirmSkip] = useState(false)
    const veteran = !!player?.genesisGranted
    // An invite link: its code waits in the war menu, once the tutorial is done.
    useEffect(() => { if (veteran && pendingInvite) openWarMenu() }, [veteran, pendingInvite]) // eslint-disable-line react-hooks/exhaustive-deps

    const run = (fn) => async (...args) => {
        setBusy(true)
        try { await fn(...args) } finally { setBusy(false) }
    }
    // A guest who signs out can't get back in: say so first.
    const onSignOut = () => {
        if (authStatus === 'anonymous' && !window.confirm('You are playing as a guest. Signing out loses this Hive for good.')) return
        signOut()
    }

    if (!player) return <div className="pt-screen"><p className="pt-dim">Loading your Hive…</p></div>

    const mySeat = (w) => (w.players.p1.uid === uid ? 'p1' : 'p2')
    const active = wars.filter(w => w.status === 'active')
    const yourMove = active.filter(w => !w.submitted[mySeat(w)]).length

    return (
        <div className="pt-home">
            <div className="pt-screen">
                <div className="pt-home__top">
                    <button className="lobby-footer-link" onClick={onSignOut}>Sign Out</button>
                </div>
                <HogTitleGroup titleClassName="lobby-title" />

                <div className="pt-status">
                    <div className="pt-arena">Arena {player.arena}</div>
                </div>

                {notice && <p className="lobby-error pt-notice" onClick={() => setNotice(null)}>{notice}</p>}

                {!veteran ? (
                    <div className="lobby-actions">
                        {confirmSkip ? (
                            <div className="lobby-card">
                                <p className="lobby-label">Skip the tutorial?</p>
                                <p className="pt-dim pt-intro">You won’t be able to play it later. Your first lots and structure go straight to your inventory, ready to place on your Hive.</p>
                                <button className="lobby-btn-primary" disabled={busy} onClick={run(skipTutorial)}>
                                    Yes, skip tutorial
                                </button>
                                <button className="lobby-btn-ghost" disabled={busy} onClick={() => setConfirmSkip(false)}>
                                    Back
                                </button>
                            </div>
                        ) : (
                            <div className="lobby-card">
                                <p className="lobby-label">New here?</p>
                                <p className="pt-dim pt-intro">A short guided war that teaches you the game.</p>
                                <button className="lobby-btn-primary" disabled={busy} onClick={run(startTutorial)}>
                                    Play Hog of War
                                </button>
                                <button className="lobby-btn-ghost" disabled={busy} onClick={() => setConfirmSkip(true)}>
                                    Skip tutorial
                                </button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="pt-home__war">
                        <GlobeArt className="pt-home__globe" />
                        <button className="lobby-btn-primary pt-home__go" onClick={openWarMenu}>Go to war</button>
                    </div>
                )}
            </div>
            {veteran && <AppNav onHive={openHive} onHistory={openHistory} toPlace={toPlace(player).count} yourMove={yourMove} />}
        </div>
    )
}
